import axios from 'axios'
import { clearLoginInfo } from '@/utils'

const http = axios.create({
	baseURL:  "https://datacenterapi.transecs.com/api/v1",
	timeout: 1000 * 30,
	// withCredentials: true,
	headers: {
		'Content-Type': 'application/json; charset=utf-8'
	}
})

/**
 * 请求拦截
 */
http.interceptors.request.use(
	(config) => {
		// debugger
		config.headers['token'] = window.sessionStorage.getItem('token') // 请求头带上token
		config.headers.Authorization = 'Bearer ' + window.sessionStorage.getItem('token')
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

/**
 * 响应拦截
 */
http.interceptors.response.use(
	(response) => {
		// debugger
		if (response.data && response.data.code === 400) {
			// 401, token失效
			clearLoginInfo()
			router.push({ name: 'login' })
		}
		return response
	},
	(error) => {
		const err = error.response.data
		if (err.message == 'Unauthenticated.' && err.meta.status == 400) {
			window.sessionStorage.clear()
			location.reload()
		}
		return Promise.reject(error)
	}
)

export default http

// axios.defaults.baseURL = "http://test.databankapi.transecs.com/api/v1";
// // axios.defaults.baseURL="http://oms.test/api/v1"
// axios.defaults.headers.post["Content-Type"] = "application/json";

// // 添加请求拦截器
// axios.interceptors.request.use(config => {
//   // 在最后必须return config
//   config.headers.Authorization =
//     "Bearer " + window.sessionStorage.getItem("token");

//   return config;
// });

// // 添加响应拦截器
// axios.interceptors.response.use(
//   function (response) {
//     // 对响应数据做点什么
//     return response;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );



// WEBPACK FOOTER //
// ./src/utils/request.js